import { useHistory, withRouter } from 'react-router';
import { useIonRouter, withIonLifeCycle } from '@ionic/react';
import React from 'react';
import { compose } from '../misc';

const withNav = (Component:React.ComponentType<any>) => (props:any) => {
    const navigateHook = useIonRouter();
    return <Component {...props} navigate={navigateHook} /> ;
};

export default compose(withRouter,withIonLifeCycle,withNav);